/**
 * Testing Helper für Custom Domain Routing
 * Kann in der Browser-Konsole verwendet werden
 */

import { isCustomDomain, resolvePageForDomain, validateDomain } from './domainHelpers';

// Test Functions für Browser Console
window.testCustomDomainRouting = {
  
  // Test Domain Detection
  testDomainDetection: () => {
    console.log('🧪 Testing Domain Detection:');
    console.log('Current hostname:', window.location.hostname);
    console.log('Is Custom Domain:', isCustomDomain());
    
    // Test verschiedene Domains
    const testDomains = [
      'localhost',
      'bonusclub.link', 
      'www.meinuser.com',
      'test.example.com'
    ];
    
    testDomains.forEach(domain => {
      // Temporarily override hostname for testing
      const originalHostname = window.location.hostname;
      Object.defineProperty(window.location, 'hostname', {
        writable: true,
        value: domain
      });
      
      const isCustom = isCustomDomain();
      console.log(`${domain}: ${isCustom ? '✅ Custom' : '❌ BonusClub'}`);
      
      // Restore original hostname
      Object.defineProperty(window.location, 'hostname', {
        writable: true,
        value: originalHostname
      });
    });
  },
  
  // Test Domain Validation
  testDomainValidation: () => {
    console.log('🧪 Testing Domain Validation:');
    
    const testDomains = [
      'www.meinuser.com',
      'meinuser.com',
      'sub.domain.com',
      'invalid-domain',
      'bonusclub.link',
      'localhost',
      'test.example.co.uk'
    ];
    
    testDomains.forEach(domain => {
      const result = validateDomain(domain);
      console.log(`${domain}: ${result.valid ? '✅ Valid' : '❌ Invalid'} ${result.error || ''}`);
    });
  },
  
  // Test Page Resolution (requires actual domain mapping in Firebase)
  testPageResolution: async (domain = 'www.meinuser.com', path = '/') => {
    console.log(`🧪 Testing Page Resolution for ${domain}${path}:`);
    
    try {
      const result = await resolvePageForDomain(domain, path);
      
      if (result) {
        console.log('✅ Page resolved:', {
          pageId: result.pageId,
          pageName: result.pageData.name,
          userId: result.domainMapping.userId,
          siteName: result.domainMapping.settings.siteName
        });
      } else {
        console.log('❌ No page found for this domain/path');
      }
    } catch (error) {
      console.error('❌ Error resolving page:', error);
    }
  },
  
  // Test URL Generation
  testUrlGeneration: () => {
    console.log('🧪 Testing URL Generation:');
    
    const testCases = [
      { domain: 'www.meinuser.com', path: '/', expected: 'https://www.meinuser.com/' },
      { domain: 'www.meinuser.com', path: '/about', expected: 'https://www.meinuser.com/about' },
      { domain: 'subdomain.example.com', path: '/shop', expected: 'https://subdomain.example.com/shop' }
    ];
    
    testCases.forEach(({ domain, path, expected }) => {
      const generated = `https://${domain}${path}`;
      const match = generated === expected;
      console.log(`${domain}${path}: ${match ? '✅' : '❌'} ${generated}`);
    });
  }
};

